namespace Matrix.Dashboards {
    export interface DatasetListColumnsRequest extends Serenity.ServiceRequest {
        DatasetCode?: string;
        Parameters?: { [key: string]: string };
    }
}
